<template>
  <div>
    <notifications width="100%"
                   position="bottom center"
                   class="pointer-none"
                   :close-on-click="true"
                   aria-live="assertive"
    >
      <template #body="props">
        <div
          class="d-flex align-items-center toast mx-auto pointer-auto"
          :class="`toast-${props.item.type}`"
          :data-cy="`notification-${props.item.type}`"
          @click="props.close"
        >
          <sdui-icon v-if="props.item.type === 'success'" class="icon-28 icon-check mr-2" />
          <sdui-icon v-if="props.item.type === 'warn'" class="icon-28 icon-info mr-2" />
          <sdui-icon v-if="props.item.type === 'error'" class="icon-28 icon-message-warning mr-2" />
          <div class="ml-2">
            <small class="white-space-pl">{{ props.item.text }}</small>
          </div>
        </div>
      </template>
    </notifications>
    <notifications
      group="update"
      position="left top"
      animation-name="slide-top"
      width="100%"
      class="top"
      :max="1"
      :close-on-click="true"
      :duration="5000"
      aria-live="assertive"
    >
      <template #body="props">
        <div class="container p-0 position-relative mt-4 message-notification sdui-shadow white-bg">
          <b-button
            v-touch:swipe.top="props.close"
            variant="transparent"
            class="notification-update d-flex justify-content-between align-items-center reset-button"
            @click="
              () => {
                props.close();
                props.item.data.uri ? $router.push(props.item.data.uri) : null;
              }
            "
          >
            <sdui-icon data-cy="notification-close" class="icon-close-o text-right text-muted" />
            <div class="notif-icon info-bg white rounded-circle d-flex justify-content-center align-items-center">
              <sdui-icon class="icon-open-chat-16 icon-24 white" />
            </div>
            <div class="notif-info pl-4">
              <h4 class="notification-title mb-1 info-dark">{{ props.item.title }}</h4>
              <div class="notification-content" data-cy="message-content">
                {{ props.item.text }}
              </div>
            </div>
          </b-button>
        </div>
      </template>
    </notifications>
    <notifications
      group="permission"
      width="100%"
      position="bottom center"
      :max="1"
      :close-on-click="true"
      :duration="3000"
      aria-live="assertive"
    >
      <template #body="{ item: { text } }">
        <div
          class="container permissions-wrapper small spacing d-flex justify-content-start position-relative br-8 align-items-center w-100"
        >
          {{ text }}
        </div>
      </template>
    </notifications>
    <notifications
      group="swLoader"
      width="100%"
      position="left bottom"
      :max="1"
      :close-on-click="false"
      :duration="5000"
      aria-live="assertive"
    >
      <template #body>
        <div data-cy="notification-sw-loader" class="d-flex align-items-center justify-content-center toast toast-neutral">
          <small class="white-space-pl">{{ $t('ui.notifications.swUpdateInstalling') }}</small>
          <sdui-loader class="ml-4" />
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'

export default {
  name: 'SduiNotifications',
  components: {
    SduiLoader,
  },

  data: () => ({}),
  computed: {},
  methods: {},
  watch: {},
  created() {},
}
</script>

<style scoped lang="scss">
.reset-button {
  font-size: pxtorem(13);
  padding: 10px 16px 10px 16px !important;
  width: inherit;
}

.toast-neutral .custom-spinner::before {
  border-top-color: $color-gray-400;
}
</style>
